import { importLibrary, setOptions } from "@googlemaps/js-api-loader";

let apiPromise = null;

function isApiLoaded() {
  return typeof window !== "undefined" && !!(window.google && window.google.maps && window.google.maps.Map);
}

// Maps can be shown when a key is configured, or when a prerendered page already includes the API script.
export function isGoogleMapsAvailable() {
  return isApiLoaded() || !!process.env.VUE_APP_GOOGLE_MAPS_KEY;
}

// Loads the Google Maps JavaScript API once and resolves with the `google` namespace.
// Pass the result to <GoogleMap :api-promise>, so every map shares the same load.
// Only call it when isGoogleMapsAvailable() is true.
export function loadGoogleMaps() {
  if (apiPromise) {
    return apiPromise;
  }

  if (isApiLoaded()) {
    apiPromise = Promise.resolve(window.google);
    return apiPromise;
  }

  setOptions({ key: process.env.VUE_APP_GOOGLE_MAPS_KEY, v: "weekly" });
  apiPromise = Promise.all([importLibrary("maps"), importLibrary("marker")]).then(() => window.google);
  return apiPromise;
}
